import Vue from 'vue';

export default {
  state: {
    contractorPage: {
      name: '',
      files: [],
    },
  },
  mutations: {
    setContractorPage(state, data) {
      state.contractorPage = data;
    },
  },
  actions: {
    getContractorPage(store) {
      const path = 'contractor';
      return Vue.prototype.$axios.get(path).then((resp) => {
        store.commit('setContractorPage', resp.data);
        return resp.data;
      });
    },
  },
};
